export default __webpack_public_path__ + "static/media/quote1.6960b33d.jpg";